import React from 'react';
import { formatDate } from '../../../../utils/dateUtils';
import { ServiceAgreementV2 } from '../../eBankingTempTypes';
import { ProductDetailRows } from './ProductDetailRows';
import {
  isActiveReferralServiceDefinitionId,
  isInvestmentProductServiceDefinitionId,
} from '../../privateBankingServiceDefinitionIds';
import { useTranslation } from 'react-i18next';

type DetailsBlockProps = { product: ServiceAgreementV2 };

export const DetailsBlock: React.FC<DetailsBlockProps> = ({ product }) => {
  const { t } = useTranslation();
  const activationDateLabel = isActiveReferralServiceDefinitionId(product.serviceDefinitionId)
    ? t('pb.productdetails.activeReferralWp.activationDate')
    : t('pb.productdetails.details.activeSince.label');
  const detailItems = [
    {
      label: t('pb.productdetails.details.createdBy.label'),
      value: product.createdBy ?? '-',
      testId: 'product-detail-created-by',
    },
    { label: activationDateLabel, value: formatDate(product.activeSince), testId: 'product-detail-active-since' },
    {
      label: t('pb.productdetails.details.closureDate.label'),
      value: formatDate(product.closureDate),
      testId: 'product-detail-closure-date',
    },
    ...(isInvestmentProductServiceDefinitionId(product.serviceDefinitionId)
      ? [
          {
            label: t('pb.productdetails.details.engagementType.label'),
            value: product.serviceModel?.engagementTypeName ?? 'upd-',
            testId: 'product-detail-engagement-type',
          },
          {
            label: t('pb.productdetails.details.serviceModel.label'),
            value: product.serviceModel?.serviceModelName ?? '-',
            testId: 'product-detail-service-model',
          },
          {
            label: t('pb.productdetails.details.productLine.label'),
            value: product.serviceModel?.productLineName ?? '-',
            testId: 'product-detail-product-line',
          },
          {
            label: t('pb.productdetails.details.productImplementation.label'),
            value: product.serviceModel?.productImplementationName ?? '-',
            testId: 'product-detail-product-implementation',
          },
          {
            label: t('pb.productdetails.details.investmentStrategy.label'),
            value: product.serviceModel?.investmentStrategyName ?? '-',
            testId: 'product-detail-investment-strategy',
          },
          {
            label: t('pb.productdetails.details.bankingServicePackage.label'),
            value: product.serviceModel?.bankingServicePackageName ?? '-',
            testId: 'product-detail-banking-service-package',
          },
          {
            label: t('pb.productdetails.details.transactionFeeModel.label'),
            value: product.serviceModel?.transactionFeeModelName ?? '-',
            testId: 'product-detail-transaction-fee',
          },
          {
            label: t('pb.productdetails.details.currency.label'),
            value: product.serviceModel?.currencyCode ?? '-',
            testId: 'product-detail-currency',
          },
        ]
      : []),
  ];

  return <ProductDetailRows rows={detailItems} />;
};
